/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Qty_PositiveInputs */

const vi_stock_out_qty_positive = /** @type {(inputs: Stock_Out_Qty_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng phải lớn hơn 0`)
};

/**

* @param {Stock_Out_Qty_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_qty_positive = /** @type {((inputs?: Stock_Out_Qty_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Qty_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_qty_positive(inputs)
});